<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Empresas</p>
        </div>    

        <div class="muven-content">
            <div class="muven-card mb-3" 
                v-for="(subscriber, index) of subscriberList" :key="index">
                <div>
                    <p class="mb-0">{{subscriber.name}}</p>
                    <p class="text-muted mb-0">{{subscriber.document}}</p>
                </div>

                <div class="muven-card-actions">
                    <button type="button" 
                        class="btn btn-outline-secondary"
                        @click="selectSubscriber(subscriber)"
                        v-if="!isSubscriberSelected(subscriber)">
                        Selecionar
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary"
                        disabled
                        v-if="isSubscriberSelected(subscriber)">
                        Selecionado
                        <fa icon="check-circle" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import subscriberManager from '@/subscriber/managers/SubscriberManager'
import storeConstants from '@/utils/constants/StoreConstants'

export default {
    name: 'subscriberListView',
    methods: {
        selectSubscriber(sub) {
            const isSameSub = sub.hasSamePublicKey(subscriberManager.getPublicKeyFromStorage())

            this.$store.dispatch(storeConstants.actions.SET_SUBSCRIBER, sub)

            if (!isSameSub) {
                this.$router.go()
            }
        },
    },
    computed: {
        ...mapState({
            subscriberList: state => state.subscriberList,
        }),
        isSubscriberSelected() {
            return (sub) => {
                return sub.hasSamePublicKey(subscriberManager.getPublicKeyFromStorage())
            }
        },
    },
}
</script>
